import { render } from "./TextReaderTooltip.vue?vue&type=template&id=1b371a68&scoped=true"
import script from "./TextReaderTooltip.vue?vue&type=script&lang=js"
export * from "./TextReaderTooltip.vue?vue&type=script&lang=js"

import "./TextReaderTooltip.vue?vue&type=style&index=0&id=1b371a68&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b371a68"]])

export default __exports__